import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

const Title = styled('h1')({
  fontFamily: 'Raleway',
  fontWeight: 700,
  fontSize: '40px',
  lineHeight: '56px',
  margin: '0',
});

const SubTitle = styled('p')(({ theme }) => ({
  fontFamily: 'Caveat',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '38px',
  color: 'rgba(255, 255, 255, 0.7)',
  position: 'relative',
  paddingLeft: '54px',
  margin: '11px 0 89px',
  [theme.breakpoints.down('md')]: {
    margin: '17px auto 90px',
    fontSize: '22px',
    paddingLeft: '34px',
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    left: '0',
    top: '19px',
    width: '40px',
    border: '1px solid',
    [theme.breakpoints.down('md')]: {
      width: '20px',
    },
  },
}));

const Gobutton = styled(Button)({
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '45px',
  display: 'flex',
  alignItems: 'center',
  border: '2px solid #402B23',
  height: '49px',
  maxWidth: 'fit-content',
  padding: '0 26px',
  color: '#fff',
  borderRadius: '0',
  margin: '0',
  '& svg': {
    marginLeft: '7px',
    width: '20px',
    height: 'auto',
  },
});

const LandingCafeCover = () => {
  return (
    <>
      <Title>Find a Cafe</Title>
      <SubTitle>find, share, like everything about coffee</SubTitle>
    </>
  );
};
export default LandingCafeCover;
